import clsx from "clsx";
import { AdditionalInfoButton } from "components/AdditionalInfoButton";
import { ChangeEventHandler, ReactElement, ReactNode } from "react";

export const UnregisteredCheckbox = (props: {
    onChange: ChangeEventHandler<HTMLInputElement>;
    disabled?: boolean;
    value?: string | number;
    checked: boolean;
    id: string;
    type?: "checkbox" | "radio";
    label: ReactNode;
    name?: string;
    additionalInfo?: ReactElement;
    isBlock?: boolean;
}) => {
    const { disabled, onChange, value, checked, additionalInfo, id, label, type = "checkbox", name, isBlock } = props;

    return (
        <div className={clsx("form-check", isBlock && "w-100")}>
            <input
                type={type}
                className="form-check-input"
                id={id}
                name={name}
                disabled={disabled}
                value={value}
                checked={checked}
                onChange={onChange}
            />

            <label htmlFor={id} className={clsx("form-check-label", isBlock && "d-block")}>
                {label}
            </label>

            {additionalInfo && <AdditionalInfoButton additionalInfo={additionalInfo} />}
        </div>
    );
};
